import * as Motion from "https://cdn.jsdelivr.net/npm/motion@latest/+esm";

const isMobile = window.matchMedia("(max-width: 576px)").matches;

Motion.inView(".fade-in", (element) => {
  const delay = isMobile ? 0 : parseFloat(element.style.transitionDelay) || 0;

  console.log(element);
  Motion.animate(
    element,
    { opacity: [0, 1], y: [20, 0] },
    { duration: 0.8, easing: [0.17, 0.55, 0.55, 1] },
  );
});

Motion.inView(".images-promotion-first", (element) => {
  Motion.animate(
    element,
    { x: [0, 30] },
    {
      duration: 0.6,
      delay: Motion.stagger(1.5),
      easing: [0.17, 0.55, 0.55, 1],
    },
  );
});

Motion.inView(".images-promotion-first", (element) => {
  Motion.animate(
    element,
    { opacity: [0, 1], x: [-100, 0] },
    {
      duration: 0.6,
      delay: Motion.stagger(1.5),
      easing: [0.17, 0.55, 0.55, 1],
    },
  );
});

Motion.inView(".images-promotion-second", (element) => {
  Motion.animate(
    element,
    { opacity: [0, 1], y: [-100, 0] },
    {
      duration: 0.6,
      delay: Motion.stagger(1.5),
      easing: [0.17, 0.55, 0.55, 1],
    },
  );
});

Motion.inView(".images-promotion-third", (element) => {
  Motion.animate(
    element,
    { opacity: [0, 1], y: [100, 0] },
    {
      duration: 0.6,
      delay: Motion.stagger(1.5),
      easing: [0.17, 0.55, 0.55, 1],
    },
  );
});

Motion.inView(".images-promotion-fourth", (element) => {
  Motion.animate(
    element,
    { opacity: [0, 1], x: [100, 0] },
    {
      duration: 0.6,
      delay: Motion.stagger(1.5),
      easing: [0.17, 0.55, 0.55, 1],
    },
  );
});
